import { ApolloClient, InMemoryCache, from, split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "apollo-utilities";
import axios from "axios";
import { getTransportCredentials } from "./screenCredentials";
import { createGraphqlConnectionHandler } from "./graphqlConnectionEvents";
import { emitLicenseError, LICENSE_ERROR_CODE } from "./licenseNotifications";

export const enableLog = false;
export const enableConsole = true;
export const puestosConAcceso = ["0", "1", "3"];

const normalizeBaseUrl = (url) => url.trim().replace(/\/+$/, "");
const serviceUrl = (baseUrl, pathname) =>
  new URL(pathname.replace(/^\/+/, ""), `${baseUrl}/`).toString();

export const APP_URL = normalizeBaseUrl(window.location.origin);
export const API_URL = normalizeBaseUrl(process.env.REACT_APP_API_URL || APP_URL);

export const getVersion = async () => {
  let respuesta = {};

  // await axios
  //   .post("https://tickets.esamba.online/sistema-tickets-api/public/api/tareasUltimaVersion", {
  //     idProyecto: "13",
  //   })
  //   .then((response) => {
  //     respuesta = response.data.data;
  //   });

  // return { version: "4.0.0", tareas: [{ pantalla: "Compras", tarea: "Fix compra directa" }] };
  return respuesta;
};

export const appPath = (pathname, query = {}) => {
  const url = new URL(pathname, `${APP_URL}/`);
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
};
// Create React App reemplaza esta referencia durante el build.
// eslint-disable-next-line no-undef
export const API_IMPRESION = process.env.REACT_APP_API_IMPRESION;

const GRAPHQL_URL = serviceUrl(API_URL, "graphql");
const WS_URL = new URL(serviceUrl(API_URL, "subscriptions"));
WS_URL.protocol = WS_URL.protocol === "https:" ? "wss:" : "ws:";

const httpLink = createUploadLink({
  uri: GRAPHQL_URL,
});

const handleGraphqlConnected = createGraphqlConnectionHandler();

const wsLink = new GraphQLWsLink(
  createClient({
    url: WS_URL.toString(),
    connectionParams: getTransportCredentials,
    on: {
      connected: () => {
        console.log("Connected to GraphQL WS");
        handleGraphqlConnected();
      },
      connecting: () => console.log("Connecting to GraphQL WS"),
      closed: () => console.log("Closed connection to GraphQL WS"),
      error: (error) => console.log("Error on GraphQL WS", error),
    },
  })
);

export const restLink = axios.create({
  baseURL: serviceUrl(API_URL, "rest/"),
  headers: {
    "Content-Type": "application/json",
    Authorization: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).token
      : "",
  },
});

restLink.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.data?.code === LICENSE_ERROR_CODE) emitLicenseError();
    return Promise.reject(error);
  }
);

const authLink = setContext((_, { headers }) => {
  //Get the token from the user in local storage
  const credentials = getTransportCredentials();

  return {
    headers: {
      ...headers,
      authorization: credentials.Authorization,
    },
  };
});

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const errorLink = onError(({ graphQLErrors, networkError }) => {
  const errors = graphQLErrors || networkError?.result?.errors || [];
  if (
    errors.some(
      (error) =>
        error?.code === LICENSE_ERROR_CODE || error?.extensions?.code === LICENSE_ERROR_CODE
    )
  ) {
    emitLicenseError();
  }
});

const transportLink = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
  },
  wsLink,
  authLink.concat(httpLink)
);
const link = from([errorLink, transportLink]);

export const client = new ApolloClient({
  link: link,
  cache: new InMemoryCache({
    typePolicies: {
      MateriaPrima: { fields: { tipoUnidad: { merge: true } } },
    },
  }),
});
